import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilityComponent } from './facility.component';
import { CasesComponent } from './cases/cases.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { CalendarViewComponent } from './calendar-view/calendar-view.component';
import { facilityRoutingModule } from './facility-routing.module';
import {MatMenuModule} from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { FilterComponent } from './filter/filter.component';
import { RoomDetailComponent } from './room-detail/room-detail.component';
import {MatSelectModule} from '@angular/material/select';
import {MatChipsModule} from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CaseDetailComponent } from './cases/case-detail/case-detail.component';
import { ScheduleCaseComponent } from './schedule/schedule-case/schedule-case.component';
import {MatSliderModule} from '@angular/material/slider';
import {MatTabsModule} from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { SchedulerCalendarComponent } from './scheduler-calendar/scheduler-calendar.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SurgeryListComponent } from './surgery-list/surgery-list.component';
import { WaitingRoomComponent } from './waiting-room/waiting-room.component';
import { CoreDetailComponent } from './cases/core-detail/core-detail.component';
import { BlockTimeComponent } from './block-time/block-time.component';
import { AddBlockComponent } from './block-time/add-block/add-block.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { RequestComponent } from './request/request.component';
import { AddFacilityComponent } from './request/add-facility/add-facility.component';
@NgModule({
  declarations: [
    FacilityComponent,
    CasesComponent,
    ScheduleComponent,
    CalendarViewComponent,
    FilterComponent,
    RoomDetailComponent,
    CaseDetailComponent,
    CoreDetailComponent,
    ScheduleCaseComponent,
    SchedulerCalendarComponent,
    SurgeryListComponent,
    WaitingRoomComponent,
    BlockTimeComponent,
    AddBlockComponent,
    RequestComponent,
    AddFacilityComponent
  ],
  imports: [
    CommonModule,
    facilityRoutingModule,
    MatMenuModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    FormsModule
  ]
})
export class FacilityModule { }
